"use client";
/* Auto-generated. Do not edit. */
/* Source: src/pages/home-modules/home-nine/sections/serviceSection.tsx */

import { SmartImage } from "@/Components";
import { renderCollectionNode, renderItemNode, renderNode } from "@/Templates/section-node-renderers";
import { FC, ComponentProps, Key, ReactNode } from "react";

type ServiceSectionServicesNinesItem = {
    key: Key | null | undefined;
    /** Detected variants: "/Templates/Doccure/img/icons/services-icon-two.svg" | "/Templates/Doccure/img/icons/services-icon-three.svg" | "/Templates/Doccure/img/icons/services-icon-four.svg" | "/Templates/Doccure/img/icons/services-icon-five.svg" | "/Templates/Doccure/img/icons/services-icon-one.svg" */
    src: string;
    /** Detected variants: "Skilled Nursing Care" | "Personal Care Assistance" | "Health Monitoring" | "Elderly Medical Care" | "Nutrition & Meal Planning" */
    h30Text: ReactNode;
    /** Detected variants: "/Templates/Doccure/img/service/services-img-one.jpg" | "/Templates/Doccure/img/service/services-img-two.jpg" | "/Templates/Doccure/img/service/services-img-three.jpg" | "/Templates/Doccure/img/service/services-img-four.jpg" | "/Templates/Doccure/img/service/services-img-five.jpg" */
    imageWithBasePath0Src: string;
    /** Detected variants: "Skilled Nursing Care" | "Personal Care Assistance" | "Health Monitoring" | "Elderly Medical Care" | "Nutrition & Meal Planning" */
    h30H30Text: ReactNode;
    /** Detected variants: "services-item-nine" */
    className?: string;
    /** Detected variants: "services-info" */
    div0ClassName?: string;
    /** Detected variants: "services-icon flex-shrink-0" */
    div0ClassName2?: string;
    /** Detected variants: "services-ico" */
    alt?: string;
    /** Detected variants: "img-fluid img-one" */
    imageWithBasePath0ClassName?: string;
    /** Detected variants: "services-content" */
    div1ClassName?: string;
    /** Detected variants: "custom-title" */
    h30ClassName?: string;
    /** Detected variants: "Personalized diet plans meal" */
    p0Text?: ReactNode;
    /** Detected variants: "description" */
    p0ClassName?: string;
    /** Detected variants: "preparation to promote balanced Diet" */
    span0Text?: ReactNode;
    /** Detected variants: "d-block" */
    span0ClassName?: string;
    /** Detected variants: "services-profile" */
    div1ClassName2?: string;
    /** Detected variants: "services-img" */
    imageWithBasePath0Alt?: string;
    /** Detected variants: "img-fluid img-one" */
    imageWithBasePath0ClassName2?: string;
    /** Detected variants: "title" */
    h30ClassName2?: string;
};
export type HomeNineServiceSectionGeneratedProps = {
    divDiv0Div0ImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">> | ((item: ServiceSectionServicesNinesItem) => Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>);
    divDiv0Div1H30H3Props?: Partial<ComponentProps<"h3">> | ((item: ServiceSectionServicesNinesItem) => Partial<ComponentProps<"h3">>);
    divDiv1ImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">> | ((item: ServiceSectionServicesNinesItem) => Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>);
    divH30H3Props?: Partial<ComponentProps<"h3">> | ((item: ServiceSectionServicesNinesItem) => Partial<ComponentProps<"h3">>);
    /** Default: "OUR SERVICES" */
    sectionDiv0Div0Div0DivText?: ReactNode;
    /** Default: "Our Trusted" */
    sectionDiv0Div0H20H2Text?: ReactNode;
    /** Default: "Services" */
    sectionDiv0Div0H20H2Text2?: ReactNode;
    sectionDiv0Div0H20H2Visible?: boolean;
    sectionDiv0Div0H20H2Renderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div0H20H2Props?: Partial<ComponentProps<"h2">>;
    /** Default: "Homecare" */
    sectionDiv0Div0H20Span0SpanText?: ReactNode;
    /** Default: "header-icon" */
    sectionDiv0Div0ImageWithBasePath0ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/bg/header-icon-nine.png" */
    sectionDiv0Div0ImageWithBasePath0ImageSrc?: string;
    sectionDiv0Div0ImageWithBasePath0ImageVisible?: boolean;
    sectionDiv0Div0ImageWithBasePath0ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div0ImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    serviceSectionServicesNines: ServiceSectionServicesNinesItem[];
    serviceSectionServicesNinesItemWrapper?: (item: ServiceSectionServicesNinesItem, content: ReactNode) => ReactNode;
    serviceSectionServicesNinesRenderer?: (defaultNode: ReactNode) => ReactNode;
    serviceSectionServicesNinesImageVisible?: boolean;
    serviceSectionServicesNinesImageRenderer?: (item: ServiceSectionServicesNinesItem, defaultNode: ReactNode) => ReactNode;
    serviceSectionServicesNinesH3Visible?: boolean;
    serviceSectionServicesNinesH3Renderer?: (item: ServiceSectionServicesNinesItem, defaultNode: ReactNode) => ReactNode;
    serviceSectionServicesNinesImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">> | ((item: ServiceSectionServicesNinesItem) => Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>);
    serviceSectionServicesNinesH3Props?: Partial<ComponentProps<"h3">> | ((item: ServiceSectionServicesNinesItem) => Partial<ComponentProps<"h3">>);
};

const HomeNineServiceSectionGenerated: FC<HomeNineServiceSectionGeneratedProps> = ({
    sectionDiv0Div0Div0DivText = "OUR SERVICES",
    sectionDiv0Div0H20H2Text = "Our Trusted",
    sectionDiv0Div0H20H2Text2 = "Services",
    sectionDiv0Div0H20H2Visible,
    sectionDiv0Div0H20H2Renderer,
    sectionDiv0Div0H20H2Props,
    sectionDiv0Div0H20Span0SpanText = "Homecare",
    sectionDiv0Div0ImageWithBasePath0ImageAlt = "header-icon",
    sectionDiv0Div0ImageWithBasePath0ImageSrc = "/Templates/Doccure/img/bg/header-icon-nine.png",
    sectionDiv0Div0ImageWithBasePath0ImageVisible,
    sectionDiv0Div0ImageWithBasePath0ImageRenderer,
    sectionDiv0Div0ImageWithBasePath0ImageProps,
    divDiv0Div0ImageWithBasePath0ImageProps,
    divDiv0Div1H30H3Props,
    divDiv1ImageWithBasePath0ImageProps,
    divH30H3Props,
    serviceSectionServicesNines,
    serviceSectionServicesNinesItemWrapper,
    serviceSectionServicesNinesRenderer,
    serviceSectionServicesNinesImageVisible,
    serviceSectionServicesNinesImageRenderer,
    serviceSectionServicesNinesH3Visible,
    serviceSectionServicesNinesH3Renderer,
    serviceSectionServicesNinesImageProps,
    serviceSectionServicesNinesH3Props,
}) => {
    return (
        <section className="services-section-nine section">
            <div className="container">
                <div className="section-header section-header-nine text-center">
                    <div className="title">
                        <span className="dot" />
                        {sectionDiv0Div0Div0DivText}
                    </div>
                    {renderNode(sectionDiv0Div0H20H2Visible, sectionDiv0Div0H20H2Renderer, (
                        <h2 className="section-title" {...(sectionDiv0Div0H20H2Props ?? {})}>
                            {" "}
                            {sectionDiv0Div0H20H2Text}
                            {" "}
                            <span className="text-primary text-decoration-underline">{sectionDiv0Div0H20Span0SpanText}</span>
                            {" "}
                            {sectionDiv0Div0H20H2Text2}
                            {" "}
                        </h2>
                    ))}
                    {renderNode(sectionDiv0Div0ImageWithBasePath0ImageVisible, sectionDiv0Div0ImageWithBasePath0ImageRenderer, (
                        <SmartImage src={sectionDiv0Div0ImageWithBasePath0ImageSrc} alt={sectionDiv0Div0ImageWithBasePath0ImageAlt} className="img-fluid img-one d-none" {...(sectionDiv0Div0ImageWithBasePath0ImageProps ?? {})} />
                    ))}
                </div>
                <div className="services-content-nine d-flex gap-4">
                    {renderCollectionNode(
                        serviceSectionServicesNines,
                        (item: ServiceSectionServicesNinesItem) => (
                            <div className={item.className ?? "services-item-nine"} key={item.key}>
                                {renderItemNode(serviceSectionServicesNinesH3Visible, serviceSectionServicesNinesH3Renderer, item, (
                                    <h3 className={item.h30ClassName2 ?? "title"} {...(typeof serviceSectionServicesNinesH3Props === "function" ? serviceSectionServicesNinesH3Props(item) : (serviceSectionServicesNinesH3Props ?? {}))} {...(typeof divH30H3Props === "function" ? divH30H3Props(item) : (divH30H3Props ?? {}))}>{item.h30H30Text}</h3>
                                ))}
                                <div className={item.div0ClassName ?? "services-info"}>
                                    <div className={item.div0ClassName2 ?? "services-icon flex-shrink-0"}>
                                        {renderItemNode(serviceSectionServicesNinesImageVisible, serviceSectionServicesNinesImageRenderer, item, (
                                            <SmartImage src={item.src} alt={item.alt ?? "services-ico"} className={item.imageWithBasePath0ClassName ?? "img-fluid img-one"} {...(typeof serviceSectionServicesNinesImageProps === "function" ? serviceSectionServicesNinesImageProps(item) : (serviceSectionServicesNinesImageProps ?? {}))} {...(typeof divDiv0Div0ImageWithBasePath0ImageProps === "function" ? divDiv0Div0ImageWithBasePath0ImageProps(item) : (divDiv0Div0ImageWithBasePath0ImageProps ?? {}))} />
                                        ))}
                                    </div>
                                    <div className={item.div1ClassName ?? "services-content"}>
                                        {renderItemNode(serviceSectionServicesNinesH3Visible, serviceSectionServicesNinesH3Renderer, item, (
                                            <h3 className={item.h30ClassName ?? "custom-title"} {...(typeof serviceSectionServicesNinesH3Props === "function" ? serviceSectionServicesNinesH3Props(item) : (serviceSectionServicesNinesH3Props ?? {}))} {...(typeof divDiv0Div1H30H3Props === "function" ? divDiv0Div1H30H3Props(item) : (divDiv0Div1H30H3Props ?? {}))}>{item.h30Text}</h3>
                                        ))}
                                        <p className={item.p0ClassName ?? "description"}>
                                            {item.p0Text ?? "Personalized diet plans meal"}
                                            {" "}
                                            <span className={item.span0ClassName ?? "d-block"}>{item.span0Text ?? "preparation to promote balanced Diet"}</span>
                                        </p>
                                    </div>
                                </div>
                                <div className={item.div1ClassName2 ?? "services-profile"}>
                                    {renderItemNode(serviceSectionServicesNinesImageVisible, serviceSectionServicesNinesImageRenderer, item, (
                                        <SmartImage src={item.imageWithBasePath0Src} alt={item.imageWithBasePath0Alt ?? "services-img"} className={item.imageWithBasePath0ClassName2 ?? "img-fluid img-one"} {...(typeof serviceSectionServicesNinesImageProps === "function" ? serviceSectionServicesNinesImageProps(item) : (serviceSectionServicesNinesImageProps ?? {}))} {...(typeof divDiv1ImageWithBasePath0ImageProps === "function" ? divDiv1ImageWithBasePath0ImageProps(item) : (divDiv1ImageWithBasePath0ImageProps ?? {}))} />
                                    ))}
                                </div>
                            </div>
                        ),
                        serviceSectionServicesNinesItemWrapper,
                        serviceSectionServicesNinesRenderer
                    )}
                </div>
            </div>
        </section>
    );
};

export default HomeNineServiceSectionGenerated;
